(function () {
  'use strict';

  function collectCartSectionIds() {
    var ids = new Set();
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) ids.add(el.dataset.sectionId);
    });
    return Array.from(ids);
  }

  function fetchSection(sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId.replace(/^shopify-section-/, ''));
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { return [sectionId, html]; })
      .catch(function () { return null; });
  }

  document.addEventListener('$spectrum:cart-actions:complete', async function (event) {
    var actions = event && event.detail && event.detail.actions;
    if (!actions || actions.length === 0) return;

    try {
      var sectionIds = collectCartSectionIds();

      var cartPromise = fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var sectionPromises = sectionIds.map(fetchSection);

      var results = await Promise.all([cartPromise].concat(sectionPromises));
      var cart = results[0];

      var sections = {};
      for (var i = 1; i < results.length; i++) {
        if (results[i]) sections[results[i][0]] = results[i][1];
      }

      var updateEvent = new Event('cart:update', { bubbles: true });
      updateEvent.detail = {
        resource: cart,
        sourceId: 'spectrum-cart-actions',
        data: {
          source: 'spectrum-cart-actions',
          itemCount: cart.item_count,
          sections: sections
        }
      };
      document.dispatchEvent(updateEvent);
    } catch (err) {
      console.warn('[spectrum:cart-actions-bridge] refresh failed', err);
    }
  });
})();
